import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useUserData } from "context/OAuth/AuthContext";

import Navbar from "@components/ui/Navbar";
import StepsStepper from "@components/common/StepsScreenComponents/StepsStepper";
import WeightGoalsForm from "@components/common/StepsScreenComponents/WeightGoalForm";
import GeneralStepForm from "@components/common/StepsScreenComponents/GeneralStepForm";
import AdviseSection from "@components/common/StepsScreenComponents/AdviseSection";
import {
  dietaryOptions,
  lifestyleOptions,
  medicalOptions,
  physicalCharacterstics,
  tasteOptions,
  weightOptions,
} from "data/dropdowndData/firstFormData";
import dietGoal from "@assets/images/MedicalViewImages/goals.png";
import tastePreference from "@assets/images/MedicalViewImages/Taste.png";
import Physical from "@assets/images/MedicalViewImages/TargetWeight.png";
import LifeStyle from "@assets/images/MedicalViewImages/Lifestyle.png";
import Medical from "@assets/images/MedicalViewImages/Medical.png";
import stepsBack from "@assets/images/stepsBack.jpg";
import { getRelevantCategories } from "@utils/ExerciseReleventCategories";
import { useTranslation } from "react-i18next";
import { updateMedicalFormFields } from "api/preferences";
import { getAutoPreference } from "api/generalServices";
import { useUI } from "context/LoadingContext";
import { useMeta } from "context/ExerciseMeta";
import { useDispatch, useSelector } from "react-redux";
import { resetFieldsData } from "Redux/slices/selectedFieldSlice";
import { useNavigate } from "react-router-dom";
// import { clearFieldsData } from "Redux/slices/selectedFieldSlice";

const MedicalViewModal = ({ setShowCreatePlan }) => {
  const { t } = useTranslation();
  const steps = [
    {
      title: t("firstFormSteps.stepsTitle.step1"),
      options: dietaryOptions,
      src: dietGoal,
    },
    {
      title: t("firstFormSteps.stepsTitle.step2"),
      options: tasteOptions,
      src: tastePreference,
    },
    {
      title: t("firstFormSteps.stepsTitle.step3"),
      options: physicalCharacterstics,
      src: Physical,
    },
    {
      title: t("firstFormSteps.stepsTitle.step4"),
      options: lifestyleOptions,
      src: LifeStyle,
    },
    {
      title: t("firstFormSteps.stepsTitle.step7"),
      options: medicalOptions,
      src: Medical,
      subtitle: t("firstFormSteps.medicalSubHeading"),
    },
    {
      title: t("firstFormSteps.stepsTitle.step8"),
      options: weightOptions,
      src: Physical,
      subtitle: "Enter your weight & timeline goals",
    },
    // {
    //   title: t("firstFormSteps.stepsTitle.step5"),
    //   options: exerciseOptions,
    //   src: Exercise,
    // },
    // { title: t("firstFormSteps.stepsTitle.step6"), options: [], src: Exercise },
    // { title: "Cuisine", options: MultiCountryCusineOptions, src: RegionalFood,subtitle:"Select Country & Multi Cuisine options" },
  ];
  const selectedSavedTags = useSelector(
    (state) => state?.userFieldsSeleceted?.tags,
  );

  const getCurrentStep = () => {
    const lastIndex = steps?.length - 1;
    for (let i = 0; i < steps?.length; i++) {
      const step = steps[i];
      if (i === lastIndex) {
        return lastIndex;
      }
      for (let opt of step.options) {
        const { key, type } = opt;

        if (type === "select" || type === "numaric") {
          if (selectedSavedTags?.[key] === "") {
            return i;
          }
        } else {
          if (
            !selectedSavedTags?.[key] ||
            selectedSavedTags?.[key]?.length < 1
          ) {
            return i;
          }
        }
      }
    }

    return lastIndex;
  };

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const { user, setMedicalView } = useUserData();
  const { setIsActionLocked } = useUI();
  const [currentStep, setCurrentStep] = useState(getCurrentStep());
  // State and handlers that need to be shared with child components
  const [selectedTags, setSelectedTags] = useState(selectedSavedTags);
  const [isAdviceLoading, setIsAdviceLoading] = useState(false);
  const [advisedConfirm, setAdviseConfirm] = useState(null);
  const [hasAdviceData, setHasAdviceData] = useState(false);
  const [adviceTimer, setAdviceTimer] = useState(0);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [isAdviseOpen, setIsAdviseOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [automaticTimeline, setAutomaticTimeLine] = useState("");
  const [automaticTargetWeight, setAutomaticTargetWeight] = useState("");
  const [automaticTargetWeightUnit, setAutomaticTargetWeightUnit] =
    useState("kg");
  const [maintenanceCalories, setMaintenanceCalories] = useState("");
  const [targetDailyCalories, setTargetDailyCalories] = useState("");
  const [dailyCalorieAdjustment, setDailyCalorieAdjustment] = useState("");
  const [goalWaistCircumference, setGoalWaistCircumference] = useState("");
  const [goalBodyFat, setGoalBodyFat] = useState("");
  const [goalSteps, setGoalSteps] = useState("");
  const [goalActiveTime, setGoalActiveTime] = useState("");
  const [goalCaloriesBurn, setGoalCaloriesBurn] = useState("");

  const [automaticDurationType, setAutomaticDurationType] = useState("");
  const [message, setMessage] = useState("");
  const [adviseError, setAviseError] = useState(false);
  const [exerciseCategories, setExerciseCategories] = useState([]);
  const { dynamicOptions } = useMeta();
  const [suggestedWorkouts, setSuggestedWorkouts] = useState([]);
  const [suggestedEquipment, setSuggestedEquipment] = useState("");
  const [suggestedDifficulty, setSuggestedDifficulty] = useState("");
  const [dailyExerciseTimePreference, setDailyExerciseTimePreference] =
    useState("");
  const [selectableDays, setSelectableDays] = useState("");
  const [isAdviseCreating, setIsAdviseCreating] = useState(false);
  const [autoSelectedTags, setAutoSelectedTags] = useState(null);
  const [automaticLoading, setAutomaticLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const InputFieldValidation = {
    yourAge: 3,
    height: 3,
    weight: 3,
    // targetWeight: 4,
    waistCircumference: 3,
    // maintenanceCalories: 4,
    // targetDailyCalories: 4,
    bodyFatPercentage: 3,
  };

  const validateInput = (key, value, label) => {
    const fieldLabel =
      key === "goalWaistCircumference" || key === "goalBodyFat"
        ? label
        : t(`firstFormSteps.${key}.label`);

    if (key !== "dailyCalorieAdjustment") {
      const maxLength = InputFieldValidation[key];

      // if (maxLength && value.toString().length > maxLength) {
      //   return t("validation.maxLength", { maxLength }); // "Maximum {maxLength} characters allowed"
      // }

      if (!value) {
        return t("validation.required", { field: fieldLabel }); // "{field} is required"
      }
      if (value < 1) {
        return t("validation.greaterThanZero"); // "Value must be greater than 0."
      }
      if (isNaN(value)) {
        return t("validation.validNumber"); // "Please enter a valid number"
      }
      if (value < 0) {
        return t("validation.nonNegative"); // "Value cannot be negative"
      }

      return null;
    }
  };

  const validateStep = () => {
    const currentOptions = steps[currentStep]?.options || [];
    let isValid = true;
    const newErrors = {};

    for (const field of currentOptions) {
      const value = selectedTags[field.key];
      const fieldLabel = t(`firstFormSteps.${field.key}.label`);

      // Validate multi-select
      if (field.type === "multi-select") {
        if (!Array.isArray(value) || value.length === 0) {
          newErrors[field.key] = t("validation.required", {
            field: fieldLabel,
          });

          isValid = false;
        }
      } else if (field.type === "select") {
        if (!value || value === "") {
          newErrors[field.key] = t("validation.required", {
            field: fieldLabel,
          });
          isValid = false;
        }
      } else if (field.type === "numeric") {
        const inputError = validateInput(field.key, value, fieldLabel, t);
        if (inputError) {
          newErrors[field.key] = inputError;
          isValid = false;
        }
      } else {
        if (!value || value === "") {
          newErrors[field.key] = t("validation.required", {
            field: fieldLabel,
          });
          isValid = false;
        }
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (autoSubmit) => {
    setLoading(true);
    setAutomaticLoading(autoSubmit);
    try {
      await updateMedicalFormFields(
        autoSubmit ? autoSelectedTags : selectedTags,
      );
      toast.info(t("toast.informationSubmit"));
      setMedicalView(false);
      dispatch(resetFieldsData());
      setShowCreatePlan(true);
      navigate("/create-my-plans");
    } catch (error) {
      console.log("Error submitting details", error);
      toast.error(t("toast.failedSubmit"));
    } finally {
      setLoading(false);
      setAutomaticLoading(false);
    }
  };

  const fecthAdvise = () => {
    if (hasAdviceData) {
      setIsAdviceLoading(true);
      setIsActionLocked(true);
      setAdviceTimer(10);
      setIsTimerRunning(true);
      setTimeout(() => {
        // setIsAdviseOpen(true);
        handleApplyGoal();
        toast.info(t("toast.adviceGenerated"));
        setAdviceTimer(0);
        setIsAdviceLoading(false);
        setIsActionLocked(false);
      }, 10000);
    } else {
      if (!isAdviseCreating) {
        setAdviceTimer(60);
        handleAdvice(true);
        setIsAdviceLoading(true);
        setIsActionLocked(true);
        setIsTimerRunning(true);
      } else {
        setIsAdviceLoading(true);
        setIsActionLocked(true);
        setIsTimerRunning(true);
        if (adviseError) {
          setAdviceTimer(60);
          handleAdvice(true);
        } else {
          setAdviceTimer(30);
        }
      }
    }
  };
  const handleAdvice = async (showToast = false) => {
    setIsAdviseCreating(true);
    try {
      const response = await getAutoPreference({
        Height: selectedTags?.height,
        Weight: selectedTags?.weight,
        "Your Age": selectedTags?.yourAge,
        "Weight Goal": selectedTags?.weightGoal,
        "Gain Muscle": selectedTags?.gainMuscle,
        "Weight Unit": selectedTags?.weightUnit,
        "Target Weight Unit": selectedTags?.targetWeightUnit,
        activity: selectedTags?.activity,
      });
      const data = response?.data;

      setAutomaticDurationType(data?.durationType);
      setAutomaticTargetWeight(data?.finalTargetWeight);
      setAutomaticTargetWeightUnit(data?.targetWeightUnit);
      setAutomaticTimeLine(data?.timeline);
      setDailyCalorieAdjustment(data?.dailyCalorieAdjustment);
      setGoalWaistCircumference(data?.goalWaistCircumference);
      setGoalBodyFat(data?.goalBodyFat);
      setMaintenanceCalories(data?.maintenanceCalories);
      setTargetDailyCalories(data?.targetDailyCalories);
      setSuggestedWorkouts(data?.workoutsCategories);
      setSuggestedEquipment(data?.equipmentCategories);
      setSuggestedDifficulty(data?.difficultiesLevel);
      setDailyExerciseTimePreference(data?.dailyExerciseTimePreference);
      setSelectableDays(data?.selectableDays);
      setGoalActiveTime(data?.targetActiveTime);
      // setGoalCaloriesBurn(data?.detailTargetBurnCalories);
      setGoalSteps(data?.goalSteps);
      setMessage(data?.message);
      setIsAdviseCreating(false);
      setAviseError(false);
      setHasAdviceData(true);
    } catch (error) {
      console.log(error);
      setHasAdviceData(false);
      if (showToast && currentStep === steps.length - 1) {
        toast.error(t("toast.failedToget"));
      }
      setIsAdviceLoading(false);
      setIsActionLocked(false);
      setAviseError(true);
      setIsAdviseCreating(false);
    }
  };

  const handleApplyGoal = () => {
    // setSelectedTags((prev) => ({
    //   ...prev,
    //   targetWeight: automaticTargetWeight,
    //   timeline: automaticTimeline,
    //   durationType: automaticDurationType,
    //   targetWeightUnit: automaticTargetWeightUnit,
    //   maintenanceCalories: maintenanceCalories,
    //   targetDailyCalories: targetDailyCalories,
    //   dailyCalorieAdjustment: dailyCalorieAdjustment,
    //   goalWaistCircumference: goalWaistCircumference,
    //   goalBodyFat: goalBodyFat,
    //   adviseMeDescription: message,
    //   workoutsCategories: suggestedWorkouts,
    //   equipmentCategories: suggestedEquipment,
    //   difficultiesLevel: suggestedDifficulty,
    //   // detailTargetBurnCalories: goalCaloriesBurn,
    //   goalSteps: goalSteps,
    //   targetActiveTime: goalActiveTime,
    //   selectableDays,
    //   dailyExerciseTimePreference,
    // }));

    setAutoSelectedTags({
      ...selectedTags,
      targetWeight: automaticTargetWeight,
      timeline: automaticTimeline,
      durationType: automaticDurationType,
      targetWeightUnit: automaticTargetWeightUnit,
      maintenanceCalories: maintenanceCalories,
      targetDailyCalories: targetDailyCalories,
      dailyCalorieAdjustment: dailyCalorieAdjustment,
      goalWaistCircumference: goalWaistCircumference,
      goalBodyFat: goalBodyFat,
      adviseMeDescription: message,
      workoutsCategories: suggestedWorkouts,
      equipmentCategories: suggestedEquipment,
      difficultiesLevel: suggestedDifficulty,
      // detailTargetBurnCalories: goalCaloriesBurn,
      goalSteps: goalSteps,
      targetActiveTime: goalActiveTime,
      selectableDays,
      dailyExerciseTimePreference,
    });

    // setErrors((prevErrors) => {
    //   const newErrors = { ...prevErrors };
    //   delete newErrors.goalBodyFat;
    //   delete newErrors.maintenanceCalories;
    //   delete newErrors.targetDailyCalories;
    //   delete newErrors.goalWaistCircumference;
    //   delete newErrors.targetWeight;
    //   delete newErrors.timeline;
    //   delete newErrors.durationType;
    //   delete newErrors.dailyCalorieAdjustment;
    //   delete newErrors.workoutsCategories;
    //   delete newErrors.equipmentCategories;
    //   delete newErrors.dailyExerciseTimePreference;
    //   delete newErrors.selectableDays;
    //   // delete newErrors.detailTargetBurnCalories;
    //   delete newErrors.goalSteps;
    //   delete newErrors.targetActiveTime;
    //   return newErrors;
    // });

    setIsAdviseOpen(false);
  };

  useEffect(() => {
    // Check if we're on step 3 (or whichever step you choose) and have required data
    if (currentStep === 3 && !hasAdviceData) {
      // Change 2 to your desired step
      const requiredFields = [
        selectedTags?.height,
        selectedTags?.weight,
        selectedTags?.yourAge,
        selectedTags?.weightGoal,
      ];

      // Only call if all required fields are filled
      if (requiredFields.every((field) => field)) {
        handleAdvice();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  useEffect(() => {
    if (hasAdviceData && isAdviceLoading && currentStep === steps.length - 1) {
      handleApplyGoal();
      toast.info(t("toast.adviceGenerated"));
      setIsAdviceLoading(false);
      setIsActionLocked(false);
      // setIsAdviseOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAdviceData]);

  const resetAdviceData = () => {
    setAutomaticDurationType("");
    setAutomaticTargetWeight("");
    setAutomaticTargetWeightUnit("");
    setAutomaticTimeLine("");
    setMessage("");
    setHasAdviceData(false);
  };

  const handleClose = (key) => {
    if (key === "cancel") {
      setOpen(false);
    } else {
      fecthAdvise();
      setOpen(false);
    }
  };

  const handleMultiSelectChange = (key, values) => {
    if (
      key === "healthConditions" ||
      key === "foodAllergies" ||
      key === "exoticDishes"
    ) {
      const lastSelected = values[values.length - 1];

      if (lastSelected === "None") {
        values = ["None"];
      } else {
        values = values.filter((v) => v !== "None");
      }
    }
    if (key === "selectableDays") {
      const lastSelected = values[values.length - 1];

      if (lastSelected === "All Days") {
        values = ["All Days"];
      } else {
        values = values.filter((v) => v !== "All Days");
      }
    }

    setSelectedTags((prev) => ({ ...prev, [key]: values }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (!values || values.length === 0) {
        updatedErrors[key] = true;
      } else {
        delete updatedErrors[key];
      }
      return updatedErrors;
    });
    if (key === "exerciseLocationPreference") {
      checkForExerciseCategories(values);
    }
  };

  const checkForExerciseCategories = (locationPreferences) => {
    const selectedLocations = (locationPreferences || []).map((loc) => {
      let locKey = loc.toLowerCase().trim();
      if (locKey === "outdoor") locKey = "outdoors";
      if (locKey === "gym") locKey = "gym";
      return locKey;
    });

    // Filter and transform the categories
    const categoriesWithLocation = exerciseCategories
      ?.map((item) => {
        const filteredItem = { category: item.category };

        // Only include locations that are selected
        ["home", "outdoors", "gym"].forEach((loc) => {
          if (
            selectedLocations.includes(loc) &&
            item[loc] &&
            item[loc].length > 0
          ) {
            filteredItem[loc] = item[loc];
          }
        });

        return filteredItem;
      })
      // Filter out categories that have no locations left
      .filter((item) => {
        // Count how many location properties exist (excluding 'category')
        const locationCount = Object.keys(item).length - 1;
        return locationCount > 0;
      });

    setExerciseCategories(categoriesWithLocation);
  };

  const handleInputChange = (key, value, label = "") => {
    if (
      key === "height" ||
      key === "yourAge" ||
      key === "weight" ||
      key === "weightGoal" ||
      key === "gainMuscle" ||
      key === "weightUnit"
    ) {
      resetAdviceData();
    }
    const error = validateInput(key, value, label);

    setSelectedTags((prev) => ({ ...prev, [key]: value }));

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (error) {
        updatedErrors[key] = error;
      } else {
        delete updatedErrors[key];
      }
      return updatedErrors;
    });
  };

  const handleSelecChange = (key, value) => {
    if (key === "activity") {
      resetAdviceData();
    }

    const updatedTags = {
      ...selectedTags,
      [key]: value,
    };
    setSelectedTags(updatedTags);

    if (key === "weightGoal" || key === "gainMuscle") {
      const cat = getRelevantCategories(
        updatedTags.weightGoal,
        updatedTags.gainMuscle,
      );

      const newRecord = exerciseCategories.filter((rec) =>
        cat.includes(rec?.category),
      );

      setExerciseCategories(newRecord);
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (!value || value === "") {
        updatedErrors[key] = true;
      } else {
        delete updatedErrors[key];
      }
      return updatedErrors;
    });
  };

  const removeTag = (key, tag) => {
    const updated = selectedTags[key].filter((t) => t !== tag);

    if (updated.length === 0) {
      setErrors((prev) => ({ ...prev, [key]: true }));
    }
    if (tag?.toLowerCase() === "carnivore") {
      localStorage.removeItem("selectedDiet");
    }
    setSelectedTags((prev) => ({
      ...prev,
      [key]: updated,
    }));

    if (key === "exerciseLocationPreference") {
      checkForExerciseCategories(updated);
    }
  };

  useEffect(() => {
    if (!isTimerRunning || adviceTimer <= 0) return;

    const interval = setInterval(() => {
      setAdviceTimer((prev) => {
        if (prev === 2 && isAdviceLoading && !hasAdviceData) {
          return prev + 10;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTimerRunning, isAdviceLoading]);

  return (
    // <Modal
    //   isOpen={showModal}
    //   className="rounded-lg w-[100%] h-[100%] font-[Lato] shadow-xl border border-gray-200 relative outline-none overflow-y-auto"
    //   overlayClassName="fixed inset-0 flex items-center justify-center backdrop-blur-sm"
    // >
    // </Modal>
    <div
      className="w-full h-[100%] overflow-y-auto bg-cover bg-center"
      style={{ backgroundImage: `url(${stepsBack})` }}
    >
      <Navbar medicalModal={true} />
      <div className="px-[20px] md:px-[35px] py-[34px] mx-auto bg-white rounded-lg mt-12 mb-6 w-full max-w-[90%] lg:max-w-[900px] xl:max-w-[1128px]">
        <StepsStepper currentStep={currentStep} steps={steps} />

        <div className="mb-0 md:mb-6 p-0">
          {currentStep === steps.length - 1 ? (
            <WeightGoalsForm
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              errors={errors}
              setErrors={setErrors}
              advisedConfirm={advisedConfirm}
              setAdviseConfirm={setAdviseConfirm}
              isAdviceLoading={isAdviceLoading}
              setOpen={setOpen}
              user={user}
              loading={loading}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              validateStep={validateStep}
              handleSubmit={handleSubmit}
              handleSelecChange={handleSelecChange}
              handleInputChange={handleInputChange}
              adviceTimer={adviceTimer}
              autoSelectedTags={autoSelectedTags}
              steps={steps}
              // Add these new props
              dynamicOptions={dynamicOptions}
              suggestedWorkouts={suggestedWorkouts}
              setSuggestedWorkouts={setSuggestedWorkouts}
              suggestedEquipment={suggestedEquipment}
              setSuggestedEquipment={setSuggestedEquipment}
              suggestedDifficulty={suggestedDifficulty}
              setSuggestedDifficulty={setSuggestedDifficulty}
              dailyExerciseTimePreference={dailyExerciseTimePreference}
              setDailyExerciseTimePreference={setDailyExerciseTimePreference}
              selectableDays={selectableDays}
              setSelectableDays={setSelectableDays}
              maintenanceCalories={maintenanceCalories}
              setMaintenanceCalories={setMaintenanceCalories}
              targetDailyCalories={targetDailyCalories}
              setTargetDailyCalories={setTargetDailyCalories}
              dailyCalorieAdjustment={dailyCalorieAdjustment}
              setDailyCalorieAdjustment={setDailyCalorieAdjustment}
              automaticTimeline={automaticTimeline}
              setAutomaticTimeLine={setAutomaticTimeLine}
              automaticTargetWeight={automaticTargetWeight}
              setAutomaticTargetWeight={setAutomaticTargetWeight}
              automaticDurationType={automaticDurationType}
              setAutomaticDurationType={setAutomaticDurationType}
              automaticTargetWeightUnit={automaticTargetWeightUnit}
              setAutomaticTargetWeightUnit={setAutomaticTargetWeightUnit}
              goalWaistCircumference={goalWaistCircumference}
              setGoalWaistCircumference={setGoalWaistCircumference}
              goalBodyFat={goalBodyFat}
              setGoalBodyFat={setGoalBodyFat}
              message={message}
              setMessage={setMessage}
              isAdviseOpen={isAdviseOpen}
              setIsAdviseOpen={setIsAdviseOpen}
              handleApplyGoal={handleApplyGoal}
              handleMultiSelectChange={handleMultiSelectChange}
              automaticLoading={automaticLoading}
            />
          ) : (
            <GeneralStepForm
              currentStep={currentStep}
              steps={steps}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
              errors={errors}
              setErrors={setErrors}
              validateStep={validateStep}
              setCurrentStep={setCurrentStep}
              loading={loading}
              handleSubmit={handleSubmit}
              dynamicOptions={dynamicOptions}
              isAdviceLoading={isAdviceLoading}
              handleSelecChange={handleSelecChange}
              handleInputChange={handleInputChange}
              removeTag={removeTag}
              handleMultiSelectChange={handleMultiSelectChange}
            />
          )}
        </div>

        <AdviseSection
          isAdviseOpen={isAdviseOpen}
          setIsAdviseOpen={setIsAdviseOpen}
          automaticTargetWeight={automaticTargetWeight}
          message={message}
          automaticTimeline={automaticTimeline}
          automaticDurationType={automaticDurationType}
          handleApplyGoal={handleApplyGoal}
          automaticTargetWeightUnit={automaticTargetWeightUnit}
          maintenanceCalories={maintenanceCalories}
          targetDailyCalories={targetDailyCalories}
          dailyCalorieAdjustment={dailyCalorieAdjustment}
          goalWaistCircumference={goalWaistCircumference}
          goalBodyFat={goalBodyFat}
          open={open}
          handleClose={handleClose}
          isAdviceLoading={isAdviceLoading}
          selectedTags={selectedTags}
          setCurrentStep={setCurrentStep}
          dynamicOptions={dynamicOptions}
          suggestedWorkouts={suggestedWorkouts}
          suggestedEquipment={suggestedEquipment}
          suggestedDifficulty={suggestedDifficulty}
          setSuggestedWorkouts={setSuggestedWorkouts}
          setSuggestedEquipment={setSuggestedEquipment}
          setSuggestedDifficulty={setSuggestedDifficulty}
          dailyExerciseTimePreference={dailyExerciseTimePreference}
          selectableDays={selectableDays}
        />
      </div>
    </div>
  );
};

export default MedicalViewModal;
